import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/95 backdrop-blur-md border-b border-salvia/30 py-3' : 'bg-transparent py-5'}`} data-id="element-121">
      <div className="container mx-auto px-5 sm:px-6 max-w-6xl flex items-center justify-between" data-id="element-122">
        {/* Brand wordmark — no link, sales funnel */}
        <span className="text-xl font-bold tracking-tighter text-forest select-none" data-id="element-123">
          GUT LABS
          <sup className="text-[0.55em] font-medium ml-0.5 tracking-tight text-salvia" data-id="element-124">
            TM
          </sup>
        </span>

        {/* Persistent CTA — the only interactive element */}
        <motion.a href="https://vyralea.com/products/biome-reset%E2%84%A2-protocolo-de-desinflamacion-y-salud-digestiva" className="relative inline-flex items-center gap-2 bg-forest text-white px-5 md:px-6 py-2.5 md:py-3 rounded-full text-xs md:text-sm font-bold hover:bg-forest-dark transition-colors shadow-lg shadow-forest/25" animate={{
        boxShadow: ['0 6px 18px rgba(27, 67, 50, 0.30)', '0 6px 28px rgba(27, 67, 50, 0.55)', '0 6px 18px rgba(27, 67, 50, 0.30)']
      }} transition={{
        duration: 2.2,
        repeat: Infinity,
        repeatDelay: 3,
        ease: 'easeInOut'
      }} data-id="element-125">
          <motion.span aria-hidden className="absolute inset-0 rounded-full bg-forest" animate={{
          opacity: [0, 0.35, 0],
          scale: [1, 1.18, 1.25]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          repeatDelay: 3,
          ease: 'easeOut'
        }} style={{
          zIndex: -1
        }} data-id="element-126" />
          <span className="relative" data-id="element-127">QUIERO MI PROTOCOLO · 9,90€</span>
          <ArrowDown className="relative w-3.5 h-3.5" strokeWidth={2.5} data-id="element-128" />
        </motion.a>
      </div>
    </motion.header>;
}